<template>
  <div class="modal fade" :id="modalId">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">

        <!-- Popup header -->
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span>
            <span class="sr-only">Close</span>
          </button>
          <h4 class="modal-title" id="myModalLabel">
            Create new influencer
          </h4>
        </div>

        <!-- Popup content -->
        <div class="modal-body row">
          <!-- Form -->

          <!-- Influencer handle -->
          <div
            class="form-group col-xs-12"
            v-bind:class="{ 'has-error': $v.influencer.handle.$error }"
          >
            <label>Influencer handle</label>
            <input
              type="text"
              class="form-control"
              placeholder="Enter influencer name"
              v-model="influencer.handle"
              @input="$v.influencer.handle.$touch()"
              >
            <span class="help-block" v-if="!$v.influencer.handle.required && $v.influencer.handle.$error">Influencer name is required</span>
          </div>
        </div>

        <!-- Footer -->
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal" ref="closeButton">Close</button>
          <button type="button" class="btn btn-primary" @click="createInfluencer">Save changes</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import influencerAPIs from './influencerAPIs'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'CreateInfluencerModal',
  props: [ 'modalId' ],
  data () {
    return {
      influencer: {
        handle: ''
      }
    }
  },
  validations: {
    influencer: {
      handle: {
        required
      }
    }
  },
  methods: {
    createInfluencer: function () {
      const { influencer } = this

      // Add influencer
      influencerAPIs.createInfluencer(influencer)
        .then(response => {
          // Return the newly added data to parent component
          this.$emit('createInfluencer', response)

          // Dismiss modal by triggering the click event on Close button
          this.$refs.closeButton.click()
        })
        .catch(error => {
          // Request failed.
          console.log('error', error)
        })
    },
    clearData: function () {
      this.influencer = {
        handle: ''
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// CreateInfluencerModal.vue?62d03be6